export const AI_ANALYSIS_POLLING_EXHAUSTED = 'info.micro_ai_analysis_polling_exhausted';

export const AI_ANALYSIS_READY = 'info.sample_ai_analysis_ready';

export const DEFAULT_SAMPLE_AI_PROGRESS_POLL_CONFIG = {
  intervalMs: 10_000,
  maxAttempts: 10,
  /**
   * How often (in poll ticks) to refresh the heavy derived data (analyzed
   * assets + detection stats) while the AI runs. Status itself is polled every
   * tick for banner accuracy, but re-aggregating stats on large samples each
   * tick is expensive, so we space it out. A final refresh is always issued
   * when the status flips to `ready`.
   */
  dataRefreshEveryNPolls: 3,
} as const;
